/* Skeleton Crew review fixes, 2026-10-12. */
(function () {
  /* Desktop (>=990px) scrolls inside .page-wrapper, so keyboard scrolling does nothing until
     the page is clicked. Give the scroller focus on load (and after the cart or menu closes)
     unless something else already has it. */
  var mq = window.matchMedia('(min-width: 990px)');
  function focusScroller() {
    if (!mq.matches) return;
    var pw = document.querySelector('.page-wrapper');
    if (!pw) return;
    var a = document.activeElement;
    if (a && a !== document.body && a !== document.documentElement) return;
    if (!pw.hasAttribute('tabindex')) pw.setAttribute('tabindex', '-1');
    try { pw.focus({ preventScroll: true }); } catch (e) { pw.focus(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', focusScroller);
  else focusScroller();
  document.addEventListener('focusout', function () { setTimeout(focusScroller, 0); });
})();
